import React from 'react'
import Contenuti from './Contenuti'
import Moduli from './Moduli'
import Obiettivi from './Obiettivi'
import Destinatari from './Destinatari'
import Costo from './Costo'
import ChiSono from './ChiSono'
import Faq from './Faq'
import Formazione from './Formazione'
import Supervisione from './Supervisione'
import Live from './Live'

export default function Home() {
    return (
        <>
        
            <Contenuti />
            <Moduli />
            <Obiettivi />
            <Destinatari />
            <Costo />
            <Formazione />
            <Supervisione />
            <Live />
            <ChiSono />            
            <Faq />

        </>
    )
}
